// src/LoginSelect.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function LoginSelect() {
  const navigate = useNavigate();

  return (
    <div className="login-select-container">
      <style>{`
        /* Harquil Font */
        @font-face {
          font-family: 'Harquil';
          src: url('/fonts/harquil.woff2') format('woff2'),
               url('/fonts/harquil.woff') format('woff'),
               url('/fonts/harquil.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          -webkit-tap-highlight-color: transparent;
        }

        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }

        .login-select-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #ffb6c1 0%, #ff69b4 100%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 20px;
          position: relative;
          overflow: hidden;
        }

        /* Animated background */
        .login-select-container::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
          animation: rotate 20s linear infinite;
          pointer-events: none;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Logo Section */
        .logo-card {
          text-align: center;
          margin-bottom: 40px;
          position: relative;
          z-index: 1;
        }

        /* Harquil Font */
        .brand-name {
          font-family: 'Harquil', cursive;
          font-size: 5rem;
          background: linear-gradient(135deg, #fff 0%, #ffe4e1 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 0 2px 10px rgba(0,0,0,0.1);
          margin-bottom: 8px;
          animation: fadeInDown 0.6s ease;
          font-weight: normal;
          letter-spacing: 2px;
        }

        .tagline {
          color: rgba(255,255,255,0.95);
          font-size: 0.85rem;
          letter-spacing: 3px;
          animation: fadeInUp 0.6s ease;
          font-weight: 500;
        }

        /* Selection Card */
        .selection-card {
          background: rgba(255, 255, 255, 0.98);
          border-radius: 32px;
          padding: 32px 24px;
          width: 100%;
          max-width: 380px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
          position: relative;
          z-index: 1;
          animation: fadeIn 0.5s ease;
        }

        .selection-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          text-align: center;
          margin-bottom: 8px;
        }

        .selection-subtitle {
          font-size: 0.8rem;
          color: #94a3b8;
          text-align: center;
          margin-bottom: 28px;
        }

        /* Buttons */
        .login-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(135deg, #ffb6c1, #ff69b4);
          color: white;
          border: none;
          border-radius: 30px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .login-btn:last-child {
          margin-bottom: 0;
        }

        .login-btn:active {
          transform: scale(0.97);
        }

        /* Footer */
        .login-footer {
          margin-top: 40px;
          text-align: center;
          position: relative;
          z-index: 1;
        }

        .footer-text {
          color: rgba(255,255,255,0.9);
          font-size: 0.7rem;
        }

        .footer-text strong {
          color: white;
          font-weight: 600;
        }

        /* Animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Mobile Optimizations */
        @media (max-width: 480px) {
          .brand-name {
            font-size: 3.5rem;
          }
          .selection-card {
            padding: 28px 20px;
          }
          .login-btn {
            padding: 14px;
            font-size: 0.95rem;
          }
          .tagline {
            font-size: 0.7rem;
            letter-spacing: 2px;
          }
        }
      `}</style>

      {/* Logo Section with Harquil Font */}
      <div className="logo-card">
        <div className="brand-name">Jauhari</div>
      </div>

      {/* Selection Card */}
      <div className="selection-card">
        <div className="selection-title">Welcome Back</div>
        <div className="selection-subtitle">Choose your login type</div>

        <button
          className="login-btn"
          onClick={() => navigate("/login")}
        >
          <span>👔</span>
          Employee Login
          <span>→</span>
        </button>

        <button
          className="login-btn"
          onClick={() => navigate("/customer")}
        >
          <span>👤</span>
          Customer Login
          <span>→</span>
        </button>
      </div>

      {/* Footer */}
      <div className="login-footer">
        <p className="footer-text">
          Powered by <strong>Jauhari WebTech</strong>
          <br />
          © 2026 All Rights Reserved.
        </p>
      </div>
    </div>
  );
}